import React from 'react';
import { Grid, FormControl, InputLabel, Select, MenuItem, Box, TextField } from '@mui/material';

type Country = 'MX' | 'US';

interface PhoneInputFieldProps {
    value: string;
    onChange: (value: string) => void;
    error?: boolean;
    helperText?: string;
    disabled?: boolean;
    autoFocus?: boolean;
}

const CountryFlag = ({ countryCode }: { countryCode: string }) => (
    <Box component="span" sx={{ mr: 1 }}>
        {countryCode === 'MX' ? '🇲🇽' : '🇺🇸'}
    </Box>
);

export const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
    value,
    onChange,
    error,
    helperText,
    disabled,
    autoFocus
}) => {
    const detectCountry = (): Country => {
        if (value.startsWith('+1')) return 'US';
        return 'MX';
    };

    const country = detectCountry();

    const handleCountryChange = (e: any) => {
        const newCountry = e.target.value as Country;
        const digits = value.replace(/\D/g, '').slice(-10);
        const prefix = newCountry === 'MX' ? '+52' : '+1';
        onChange(`${prefix}${digits}`);
    };

    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const digits = e.target.value.replace(/\D/g, '');
        const prefix = country === 'MX' ? '+52' : '+1';
        onChange(`${prefix}${digits}`);
    };

    return (
        <Grid container spacing={2}>
            {/* 4/12 con el valor COMPACTO (bandera + lada): con «México (+52)» completo el
                texto se cortaba a media palabra en un teléfono de 375 px. El nombre largo
                se conserva dentro del menú, donde sí hay espacio. */}
            <Grid size={{ xs: 4 }}>
                <FormControl fullWidth>
                    <InputLabel>País</InputLabel>
                    <Select
                        value={country}
                        onChange={handleCountryChange}
                        label="País"
                        renderValue={(value) => (
                            <Box display="flex" alignItems="center">
                                <CountryFlag countryCode={value as string} />
                                {value === 'MX' ? '+52' : '+1'}
                            </Box>
                        )}
                    >
                        <MenuItem value="MX">
                            <Box display="flex" alignItems="center">
                                <CountryFlag countryCode="MX" />
                                México (+52)
                            </Box>
                        </MenuItem>
                        <MenuItem value="US">
                            <Box display="flex" alignItems="center">
                                <CountryFlag countryCode="US" />
                                USA (+1)
                            </Box>
                        </MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{ xs: 8 }}>
                <TextField
                    fullWidth
                    label="Teléfono"
                    placeholder="10 dígitos"
                    name="customerPhone"
                    value={value.replace(/^(\+52|\+1)/, '')}
                    onChange={handlePhoneChange}
                    error={error}
                    helperText={helperText}
                    inputProps={{
                        inputMode: 'tel',
                        maxLength: 10,
                        form: {
                            autocomplete: 'off'
                        }
                    }}
                    disabled={disabled}
                    autoFocus={autoFocus}
                />
            </Grid>
        </Grid>
    );
};
